import ReactMarkdown from "react-markdown";
import { BookOpen } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function ManualCitationLink({
  anchor,
  title,
  bodyMarkdown,
  children,
}: {
  anchor?: string;
  title?: string;
  bodyMarkdown?: string;
  children?: React.ReactNode;
}) {
  if (!bodyMarkdown) return null;
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="inline-flex items-center gap-1.5 text-xs font-medium text-brand hover:underline">
          <BookOpen className="h-3.5 w-3.5" strokeWidth={2} />
          {children ?? "Manual Citation"}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title ?? "Policy manual"}</DialogTitle>
          {anchor && <DialogDescription>{anchor}</DialogDescription>}
        </DialogHeader>
        <div className="prose prose-sm prose-neutral max-w-none dark:prose-invert">
          <ReactMarkdown>{bodyMarkdown}</ReactMarkdown>
        </div>
      </DialogContent>
    </Dialog>
  );
}
